<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraPremio />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraPremio from "../Components/Leituras/LeituraPremio.vue";
export default {
  name: "ReadReserve",
  components: {
    LeituraPremio,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>